




import { Component, mixins } from '@niknevis/vue-modules'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import { InjectReactive } from 'vue-property-decorator'
import { InvoiceItemResourceModel } from '@/modules/invoice-item/models/invoice-item-resource.model'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'

@Component({
  components: {
    TesTr
  }
})
export default class AdminInvoiceItemTableRow extends mixins<TesTableRow>(TesTableRow) {
  @InjectReactive()
  invoiceItems!: InvoiceItemResourceModel[]
  private columnComponents = {
    title: {
      component: TextEllipsis,
      handler: (value, row) => ({ text: row.title })
    },
    price: {
      component: PriceView,
      handler: (value, row) => ({ price: row.price, class: 'row items-center' })
    },
    discount: {
      component: PriceView,
      handler: (value, row) => ({ price: row.discount, class: 'row items-center' })
    },
    payable: {
      component: PriceView,
      handler: (value, row) => ({ price: row.payable, class: 'row items-center' })
    }
  }
}
